// extracted by mini-css-extract-plugin
module.exports = {"table":"BacktestHistory_table__v3ES2"};